import { render, staticRenderFns } from "./CRIcon.vue?vue&type=template&id=46e6d61f&scoped=true"
import script from "./CRIcon.vue?vue&type=script&lang=js"
export * from "./CRIcon.vue?vue&type=script&lang=js"
import style0 from "./CRIcon.vue?vue&type=style&index=0&id=46e6d61f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e6d61f",
  null
  
)

export default component.exports